/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'euro_symbol': {
    width: 60,
    height: 60,
    viewBox: '0 0 60 60',
    data: '<path pid="0" d="M40.08 44.3c-1.813.333-3.567.307-5.26-.08a13.315 13.315 0 01-4.68-2.02 14.447 14.447 0 01-3.64-3.62c-1-1.453-1.72-3.073-2.16-4.86h-4.4v-2.14h4.02v-3.14h-4.02V26.3h4.4c.453-1.813 1.186-3.447 2.2-4.9a14.17 14.17 0 013.68-3.62 13.325 13.325 0 014.66-2.02c1.68-.387 3.413-.413 5.2-.08v2.86c-1.453-.32-2.853-.353-4.2-.1-1.334.253-2.567.74-3.7 1.46a11.469 11.469 0 00-2.96 2.72 12.01 12.01 0 00-1.88 3.68h6.62v2.14H26.8v3.14h7.16v2.14h-6.6a11.689 11.689 0 001.9 3.72 11.161 11.161 0 002.96 2.7 10.61 10.61 0 003.72 1.42c1.346.227 2.727.18 4.14-.14v2.88z" _fill="#000230"/>'
  }
})
